<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--dark"
  >
    <div class="layout__component-container layout__component-container--dark">
      <div class="account__title-line">
        <h2
          class="text-size-xl weight--bold layout--margin-bottom-xs layout--ellipses"
        >
          {{ (timer && timer.widget.name) || "Timer Details" }}
        </h2>
        <router-link
          :to="{ name: 'dashboard overview' }"
          class="link account__back-link layout--margin-right-sm"
          ><IconArrowBack class="icon layout--margin-right-xs" />Back to
          Dashboard</router-link
        >
      </div>
      <div class="account__main-content" v-if="timer">
        <form class="account__form-wrap">
          <div
            class="account__form-section-wrap account__form-section-wrap--wide"
          >
            <fieldset class="account__form-section account__form-section--wide">
              <TimerCode :code="timer.apiUrl" />
            </fieldset>
            <fieldset
              class="account__form-section account__form-section--wide layout--padding-left-none layout--padding-right-none layout--padding-top-none layout--padding-bottom-sm"
            >
            <v-wait for="loading edit timer data">
              <spring-spinner
                :animation-duration="1500"
                :size="53"
                :color="'#b6bbff'"
                transition="fade"
                mode="out-in"
                :duration="1000"
                enter-active-class="enter-active"
                style="margin-left: auto; margin-right: auto; padding: 40px;"
                slot="waiting"
              />
              <TimerPreview :timer="timer" />
            </v-wait>
            </fieldset>
          </div>
          <div
            class="account__form-section-wrap account__form-section-wrap--narrow"
          >
            <fieldset
              class="account__form-section account__form-section--wide account__form-section--full-width"
            >
              <FAQ />
            </fieldset>
          </div>
        </form>
      </div>
      <!-- display error if timerId doesn't match any timers on user's account -->
      <div v-if="!timer" role="alert">
        <div class="account__form-section account__form-section--wide">
          Timer not found!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapWaitingActions } from "vue-wait";
import TimerCode from "../components/TimerCode";
import TimerPreview from "../components/TimerPreview";
import FAQ from "./timer-details/FAQ";

import { mapGetters, mapMutations } from "vuex";

import IconArrowBack from "../assets/icons/iconArrowBack.svg";

export default {
  name: "timer-details",
  components: { TimerCode, TimerPreview, FAQ, IconArrowBack },
  mounted() {
    const getTimerDetails = () => {
      // wait for timer list to load, replace it with more detailed data
      if (this.timer) {
        this.getTimerInfo(this.$route.query.timerId).then(timer => {
          this.setTimer(timer);
        });
        return;
      }
      setTimeout(getTimerDetails, 100)
    }
    getTimerDetails();
  },
  methods: {
    ...mapWaitingActions("timers", {
      getTimerInfo: "loading edit timer data",
    }),
    ...mapMutations("timers", [ "setTimer" ]),
  },
  computed: {
    ...mapGetters("timers", ["timerById"]),
    /**
     * Look up timer using the timerId provided in the query string
     */
    timer: function() {
      if (this.$route.query.timerId) {
        return this.timerById(parseInt(this.$route.query.timerId));
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/pages/_timerDetails.scss";
</style>
